import React, { Suspense } from 'react';
import CircularProgress from '../../../components/CircularProgress';

const DashboardTable = React.lazy(() => import('../components/DashboardTable'));
function SafetyOfCargoView(props: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <DashboardTable {...props} />
    </Suspense>
  );
}

export default SafetyOfCargoView;
